







































































































import { CompanyUserParams, User } from '@/store/interfaces/companyUser';
import root from '@/store/types/root';
import companyUser from '@/store/types/companyUser';
import permissionGroup from '@/store/types/permissionGroup';
import { AxiosResponse } from 'axios';
import { TeipNotifications } from '@/util/teipNotifications';
import { ValidationProvider } from 'vee-validate';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import teipSelect from 'teip-components/dist/@types/src/components/selects/teipSelect.vue';

type BasicInfoUser = {
  first_name: string;
  last_name: string;
};
interface formValidatorContactModal
  extends InstanceType<typeof ValidationProvider> {
  fields: {
    email: {
      valid: boolean;
    };
  };
}

export default Vue.extend({
  name: 'AddTeipBizUser',
  props: {
    userUpdate: {
      type: Object as PropType<CompanyUserParams>,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    saveIsSuccess: {
      type: Boolean,
      required: true,
    },
    viewModal: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    disabledButton: true,
    disabled: true,
    messageButton: 'Guardar usuario',
    update: false,
    email: '',
    user: {
      first_name: '',
      last_name: '',
      id: '',
      permission_group_id: '',
    },
    positionContactKind: 1,
    loading: true,
    contactKind: [],
    userFound: false,
  }),
  computed: {
    ...mapGetters({
      getProcess: root.getters.GET_START_PROCESS,
      permissions: `permissionGroupModule/${permissionGroup.getters.GET_PERMISSIONS_GROUP_LIST}`,
    }),
    syncedViewModal: {
      get(): boolean {
        return this.$props.viewModal;
      },
      set(val: boolean): void {
        if (this.$data.update) this.cleanModel();
        this.$emit('update:viewModal', val);
      },
    },
  },
  async created() {
    await this.permissionGroupList('kind_eq=1');
    this.loading = false;
  },
  methods: {
    ...mapActions({
      CompanyUserList: `companyUserModule/${companyUser.actions.SEARCH_USER}`,
      permissionGroupList: `permissionGroupModule/${permissionGroup.actions.PERMISSION_GROUP_LIST}`,
    }),
    async searchUser() {
      const isValid = (this.$refs.formValidatorContactModal as formValidatorContactModal).fields.email.valid;
      if (isValid) {
        this.CompanyUserList(`email_eq=${this.$data.email}`)
          .then((res: AxiosResponse) => {
            if (res.data.data.length > 0) {
              const user: User = res.data.data[0];
              this.user.id = user.id || '';
              this.email = user.email || '';
              this.user.first_name = user.profile?.first_name;
              this.user.last_name = user.profile?.last_name;
              this.userFound = true;
              this.disabled = true;
            } else {
              this.user = this.initData().user;
              this.userFound = false;
              this.disabled = false;
              (this.$refs.formValidatorContactModal as formValidatorContactModal).reset();
            }
          })
          .catch(() => {
            this.$data.disabled = true;
            const notification = new TeipNotifications();
            notification.warning('Algo salió mal al buscar tu contacto :(');
          });
      }
    },
    initData() {
      return {
        user: {
          first_name: '',
          last_name: '',
          id: '',
          permission_group_id: '',
        },
      };
    },
    cleanModel() {
      if (this.$refs.formValidatorContactModal as formValidatorContactModal) {
        (
          this.$refs.formValidatorContactModal as formValidatorContactModal
        ).reset();
      }
      const values = {
        id: '',
        first_name: '',
        last_name: '',
        permission_group_id: '',
      };
      (
        this.$refs.userPermission as InstanceType<typeof teipSelect>
      ).$data.select = '';
      this.userFound = false;
      this.email = '';
      this.user = values;
    },
    contactAction() {
      const user: CompanyUserParams = {
        user: {
          email: this.email,
          profile: {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
          },
        },
        permission_group_id: this.user.permission_group_id,
      };
      this.user.id && (user.id = this.user.id);
      let contactInfo = {
        update: false,
        user,
      };
      if (this.update) {
        contactInfo = {
          update: true,
          user,
        };
      }
      this.disabled = true;
      this.disabledButton = true;
      this.$emit('contactInfo', contactInfo);
    },
    cancel() {
      this.cleanModel();
      this.syncedViewModal = false;
      this.disabled = true;
      this.disabledButton = true;
    },
  },
  watch: {
    errors: {
      immediate: true,
      deep: true,
      handler(errorsToServer: string[]) {
        if (this.$refs.formValidatorContactModal as formValidatorContactModal) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const errors: any = [];
          Object.entries(errorsToServer).forEach(([key, value]) => {
            const inputKeyName = key.split('.')[1];
            if (inputKeyName === 'email') {
              errors.email = value;
            } else {
              errors[key] = value;
            }
          });
          (
            this.$refs.formValidatorContactModal as formValidatorContactModal
          ).setErrors(errors);
        }
      },
    },
    saveIsSuccess: {
      deep: true,
      handler(success: boolean) {
        if (success) this.cleanModel();
      },
    },
    userUpdate: {
      immediate: true,
      deep: true,
      handler(val: CompanyUserParams) {
        if (Object.keys(val).length > 0) {
          this.cleanModel();
          this.update = true;
          this.messageButton = 'Actualizar usuario';
          this.email = val.user?.email || '';
          this.user.first_name = val.user?.profile?.first_name || '';
          this.user.last_name = val.user?.profile?.last_name || '';
          this.user.permission_group_id = val.permission_group_id || '';
          (
            this.$refs.userPermission as InstanceType<typeof teipSelect>
          ).$data.select = val.permission_group_id;
        } else {
          this.update = false;
          this.messageButton = 'Guardar usuario';
        }
      },
    },
    user: {
      deep: true,
      handler(val: BasicInfoUser) {
        if (val.first_name && val.last_name) {
          this.disabledButton = false;
        } else {
          this.disabledButton = true;
        }
      },
    },
  },
});
